module.exports = __webpack_public_path__ + "static/media/3DPPA4.fda38a3f.jpg";